import React, {useState, useEffect, useRef} from 'react';
import ShowRuleModal from "./showRuleModal";

const ShowRuleComponent = (props) => {
    const {dataSourceHold, fieldName, conditions, onOk} = props;
    const [rulesToDisplay, setRulesToDisplay] = useState(null);
    const modalRef = useRef(null);

    useEffect(() => {
        if (conditions?.length && showRules(dataSourceHold, conditions)) {
            setRulesToDisplay(renderRules());
        } else {
            setRulesToDisplay(null);
        }
    }, [conditions])

    const showRules = (dataSourceHold = [], rules = []) => {
        const filterRules = rules?.length ? rules.filter(condition =>
            dataSourceHold.some(item => item.dbFieldName === condition.field?.key)
        ) : [];
        // every 方法的行为定义为：如果数组为空或者数组中的所有元素都满足提供的测试函数，则返回 true
        if (filterRules.length === 0) {
            return false;
        }
        return filterRules.every(condition => {
            if (!condition?.field || !condition?.option) return false;
            const hasFieldValues = condition.field.key && condition.field.value;
            const hasOptionValues = condition.option.every(opt => opt.key && opt.value);
            return hasFieldValues && hasOptionValues;
        })
    }

    const showAddModal = () => {
        let data = [
            {
                field: {key: "", value: ""},
                option: [{key: "", value: ""}],
                operate: "is",
                method: "includes"
            }
        ]
        modalRef.current.setData(data);
    };

    const showEditModal = () => {
        modalRef.current.setData(conditions);
    };

    const handleDelete = () => {
        setRulesToDisplay(null)
        onOk(null);
    };

    const renderRules = () => {
        if (!conditions || conditions.length === 0) return null;
        const formatOptions = (option) => {
            const formattedOptions = option.map(opt => `"${opt.value}"`);
            return formattedOptions.join('、');
        };

        const renderCondition = (cond, index, isLastCondition) => {
            let formattedCondition = `当“${cond.field.value}”选择${formatOptions(cond.option)}`;
            if (index > 0) {
                formattedCondition = `${cond.operate === 'is' ? '且' : '或'} ${formattedCondition}`;
            }
            return isLastCondition ? `${formattedCondition}时` : formattedCondition;
        };

        return (
            <>
                {conditions.map((cond, index) => (
                    <React.Fragment key={index}>
                        {renderCondition(cond, index, index === conditions.length - 1)}
                        {index < conditions.length - 1 && <br/>}
                    </React.Fragment>
                ))}
                <div>显示字段“{fieldName}”</div>
                <div>
                    <span style={{color: "#0050B3", cursor: 'pointer'}}
                          onClick={() => showEditModal()}>修改</span>
                    <span style={{color: "red", cursor: 'pointer', marginLeft: '10px'}}
                          onClick={() => handleDelete()}>删除</span>
                </div>
            </>
        );
    };

    return (
        <>
            {rulesToDisplay ? rulesToDisplay :
                <span style={{color: '#1890ff', cursor: 'pointer'}} onClick={showAddModal}>
                去设置
            </span>}
            <ShowRuleModal
                ref={modalRef}
                fieldName={fieldName}
                dataSourceHold={dataSourceHold}
                conditions={conditions}
                onOk={onOk}
            />
        </>
    );
};

export default ShowRuleComponent;
